export enum TransactionConsumerPlanType {
  TCPT_UNSET_STATE = 'TCPT_UNSET_STATE',
  TCPT_UNKNOWN = 'TCPT_UNKNOWN',
  TCPT_REWARD = 'TCPT_REWARD',
  TCPT_GIFT = 'TCPT_GIFT',
  TCPT_PAYMENT = 'TCPT_PAYMENT',
  TCPT_DATARECEIVED = 'TCPT_DATARECEIVED',
  TCPT_DATASENT = 'TCPT_DATASENT',
  TCPT_PREPROVISION = 'TCPT_PREPROVISION',
}
